<template>
  <section class="lg:bg-primary-tangerine">
    <BaseContainer>
      <div class="flex items-center justify-between h-[62px]">
        <!-- Header -->
        <header
          class="font-bold text-[#423C38] lg:text-primary-white text-xl lg:text-2xl"
        >
          <h1 v-if="!search">
            {{ props.title }}
          </h1>
          <h1 v-else>
            <span class="text-2xl font-normal"
              >{{ displayCommaNumber(hits) }}
              {{ $t('products.resultSearch') }}</span
            >
            <span class="text-2xl font-bold ml-4">“{{ search }}”</span>
          </h1>
        </header>

        <div class="hidden lg:block">
          <DropdownSelect
            intent="ghost"
            :label="$t('products.sortBy') + ': '"
            :options="productSortOption"
            :default="sortBy"
            @change="(next) => handleSortChange(next)"
          />
        </div>
      </div>
    </BaseContainer>
  </section>

  <section
    v-if="props.isSortingOpen"
    class="flex flex-col lg:hidden fixed top-0 left-0 w-screen h-screen bg-primary-white z-40 pt-5 px-5"
  >
    <div class="border-b pb-5 px-5 -mx-5 flex items-center justify-between">
      <div class="text-xl font-bold">{{ $t('products.sortBy') }}</div>
      <div class="cursor-pointer" @click="() => emit('close')">
        <Icon name="times" />
      </div>
    </div>

    <div
      class="flex-1 gap-y-6 px-5 -mx-5 py-2 bg-gray-10 overflow-scroll"
      data-scroll-lock-scrollable
    >
      <Radio
        v-for="option in productSortOption"
        :key="option.value"
        class="py-2 bg-transparent"
        name="sortBy"
        :value="option.value"
        :selected="option.value === sortBy"
        @change="(next) => handleSortChange(next)"
        >{{ option.label }}
      </Radio>
    </div>
  </section>
</template>

<script lang="ts" setup>
import scrollLock from 'scroll-lock'

const emit = defineEmits<{
  (e: 'change', value: string): void
  (e: 'close'): void
}>()
const props = defineProps<{
  title: string
  isSortingOpen: boolean
  hits: number
}>()

const route = useRoute()
const router = useRouter()
const sortBy = computed(() => (route.query.sortBy as string) || 'relevent')
const search = computed(() => (route.query.search as string) || '')

const { t } = useI18n()

const handleSortChange = (next: string) => {
  emit('change', next)
  scrollLock.enablePageScroll()
  emit('close')
  router.push({ query: { ...route.query, sortBy: next } })
}

const productSortOption = [
  {
    label: t('products.sortRelavent'),
    value: 'relevent'
  },
  {
    label: t('products.bestSelling'),
    value: 'best_selling'
  },
  {
    label: t('products.sortPriceLow'),
    value: 'price_asc'
  },
  {
    label: t('products.sortPriceHigh'),
    value: 'price_desc'
  },
  {
    label: t('products.sortNewest'),
    value: 'desc'
  }
]
</script>
